import { Modal } from "react-bootstrap"
import ButtonClose from "./ButtonClose"
import "./modal.css"

const ModalCobertura = (props) => {

    const handleClose = () => props.close(false)

    return (
        <>
        <div className="d-none d-lg-block ">

             <Modal show={props.show} onHide={handleClose} size="lg" centered>
                <Modal.Body>
                    <ButtonClose close={handleClose} />
                    <div className='modal__groups  '>
                        <div className="modal__group ">
                            <div className="modal__descripcion mb-5">
                                <h3 className="modal__titulo">{props.titulo}</h3>
                                <p dangerouslySetInnerHTML={{ __html: props.desc }}></p>
                            </div>
                        </div>
                        <div className="modal__group">
                            <div className="modal__descripcion">
                               <h3>¿Qué no cubre tu seguro?</h3>
                                {
                                    props.titulo === 'Compra protegida' && <p>Robo ocurrido:</p>
                                }
                                <ul className="list__modal"> 
                                    {
                                        props.coberturasDesc && (
                                            props.coberturasDesc.map((desc, index) => {
                                                return (
                                                    <li key={index+'li'} className="d-flex">{desc.descripcionCobertura}</li>
                                                    )
                                                })
                                            )
                                        }
                                </ul>
                                <br/>
                                <p>*Esta información muestra los aspectos más relevantes de tu seguro, te recomendamos revises las Condiciones Generales del mismo.</p>
                            </div>
                        </div>
                    </div> 
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
        </div>
        </>
    )
}

export default ModalCobertura